export const catalog = {
    "title": "Catálogos",
    "subcategory": "Subcategoría",
    "provider": "Proveedor",
    "noProvider": "No se encuentran proveedores",
    "noCatalog": "No se encuentran categorías",
    "servicesCatalog": "Catálogo de servicios",
    "catalogServices": "Servicios/Categorías del catálogo",
    "priority": {
        1: "Alta",
        2: "Media",
        3: "Baja",
        4: "Urgente"
    },
    "tags": {
        "name": "Nombre del catálogo",
        "associatedCategories": "# Categorías asociadas",
        "relationsCount": "# Relaciones como sublista",
        "state": "Estado",
        "actions": "Acciones",
        "errors": {
            "category": "El campo nombre de la categoría es requerido",
            "subCategory": "El campo nombre de la subcategoría es requerido",
        }
    },
    "form": {
        "createTitle": "Nuevo catálogo",
        "updateTitle": "Edición de catálogo",
        "deleteTitle": "Eliminar categoría",
        "deleteTitleSubService": "Eliminar subcategoría",
        "deleteCatalog": "Eliminar catálogo",
        "deleteDescription": "¿Estás seguro que desea eliminar la categoría?",
        "deleteSubServiceDescription": "¿Estás seguro que desea eliminar la subcategoría?",
        "deleteCatalogDescription": "¿Estás seguro que desea eliminar el catálogo?",
        "changePriority": "Cambiar prioridad",
        "changePriorityDescription": "¿Estás seguro que deseas cambiar la prioridad de la subcategoría? Se eliminará el proveedor asignado.",
        "crud": {
            "categoryName": "El campo nombre de la categoría es requerido",
            "subCategoryName": "El campo nombre de la subcategoría es requerido",
            "catalogName": "El campo nombre del catálogo es requerido"
        },
    },
    "button": {
        "addService": "Agregar categoría",
        "addSubService": "Agregar subcategoría",
        "edit": "Editar",
        "save": "Guardar",
        "selectAll": "Seleccionar todo",
        "deselectAll": "Deseleccionar todo",
        "assign": "Asignar",
        "cancel": "Cancelar",
    },
    "messages": {
        "addCategory": "Agregar categoría",
        "editCategory": "Editar categoría",
        "editSubCategory": "Editar subcategoría",
        "addSubCategory": "Asignar subcategoría",
        "selectProvider": "Seleccionar proveedor",
        "assignProviders": "El proveedor seleccionado se asignará a todas las subcategorías de esta categoría.",
        "assignProviderSubCategory": "El proveedor que seleccione estará asignado a esta subcategoría",
        "hasBeenSavedSuccessfully": "Se ha guardado exitosamente",
        "yourModificationHasBeenSuccessful": "Su modificación ha sido exitosa",
        "hasBeenAssignedSucessfully": "Se ha asignado exitosamente"
    },
    "inputs": {
        "textField": "Requiere campo de texto",
        "category": "Ingresar categoría",
        "enterCategory": " Ingrese categoría",
        "subCategory": "Ingresar subcategoría",
        "priority": "Asigne prioridad",
        "provider": "Asigne proveedor",
        "searchProvider": "Buscar proveedor",
        "searchProviderOrCatalog": "Buscar catálogo o proveedor",
        "catalogName": "Nombre del catálogo",
        "searchCatalog": "Buscar"
    },
    "modal": {
        "cancel": {
            "title": "Confirmación",
            "description": "¿Está seguro que desea salir? Se perderán los cambios no guardados."
        },
        "delete": {
            "success": {
                "title": "El catálogo se eliminó exitosamente"
            },
            "error": {
                "title": "Hay un error y el catálogo no puede ser eliminado"
            },
        },
        "create": {
            "success": {
                "title": "El catálogo se creó exitosamente"
            },
            "error": {
                "title": "Hay un error y el catálogo no puede ser creado"
            },
        },
        "update": {
            "success": {
                "title": "El catálogo se actualizó exitosamente"
            },
            "error": {
                "title": "Hay un error y el catálogo no puede ser actualizado"
            },
        },
        "statusUpdate": {
            "success": {
                "title": "El estado del catálogo se actualizó"
            },
            "error": {
                "title": "Hay un error y el estado del catálogo no puedó ser actualizado"
            },
        }
    },
    "snackbar": {
        "create": {
            "error": "No fue posible completar la creación del catálogo.",
            "success": "La creación del catálogo se realizó con éxito."
        },
        "edit": {
            "error": "No fue posible completar la edición del catálogo.",
            "success": "La edición del catálogo se realizó con éxito."
        }
    }
}